import React, { useEffect } from "react";
import "./Sidebar.css"
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AuthLogout } from "../../Redux/Actions/ActionAuth";
import logo from '../../images/absherr.png'

const Sidebar = ({ sidebarOpen, closeSidebar }) => {
    let role = localStorage.getItem('roleA');
    let dispatch = useDispatch();
    let navigate = useNavigate()
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    useEffect(() => {
        i18n.changeLanguage(localStorage.getItem('absherLang'));
    }, []);
    const logout = event => {
        event.preventDefault();
        dispatch(AuthLogout(navigate))
    }
    return (
        <div className={sidebarOpen ? "sidebar_responsive" : ""} id={langLocal == "ar" ? "sidebar_ar" : "sidebar_en"} >
            <div className="sidebar_title" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <i className="fa fa-times" id="sidebarIcon" onClick={() => closeSidebar()}></i>
                <div className="sidebar_img">
                    <img src={logo} />
                    <div className="sidebar_info">
                        <h1 className={langLocal === 'ar' ? "margin_right_20" : "margin_left_20"} >Ebsher</h1>
                    </div>
                </div>
            </div>
            <div className="sidebar_menu">
                <NavLink className="linkk" exact to="/">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-home"></i>
                        <span> {t('dashboard')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/categories">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/categories" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-sort"></i>
                        <span> {t('categories')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/sub-category">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/sub-category" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-sort"></i>
                        <span> {t('subCategory')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/vendors">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/vendors" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-users"></i>
                        <span> {t('vendors')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/banner">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/banner" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-image"></i>
                        <span> {t('Banner')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/category-ads">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/category-ads" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-sort"></i>
                        <span> {t('categoryAd')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/main-ads">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/main-ads" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-image"></i>
                        <span> {t('mainAds')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/users">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/users" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-users"></i>
                        <span> {t('users')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/packages">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/packages" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-table"></i>
                        <span> {t('packages')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/social-media">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/social-media" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-facebook"></i>
                        <span> {t('socialmed')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/stories">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/stories" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-video-camera"></i>
                        <span> {t('stories')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/reels">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/reels" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-video-camera"></i>
                        <span> {t('reels')} </span>
                    </div>
                </NavLink>
                <NavLink className="linkk" exact to="/reviews">
                    <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/reviews" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                        <i className="fa fa-star"></i>
                        <span> {t('reviews')} </span>
                    </div>
                </NavLink>
                {
                    role !== '2' && (
                        <NavLink className="linkk" exact to="/settings">
                            <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link ${window.location.pathname === "/settings" ? "active_menu_link" : ""} ${langLocal === 'ar' ? "border_right" : "border_left"}`}>
                                <i className="fa fa-cog"></i>
                                <span> {t('setting')} </span>
                            </div>
                        </NavLink>
                    )
                }
                <div dir={langLocal == "ar" ? "rtl" : "ltr"} className="sidebar_logout" onClick={logout} >
                    <i className="fa fa-power-off"></i>
                    <a href="#">{t('logout')}</a>
                </div>
                <br></br><br></br>
            </div>
        </div>
    )
}

export default Sidebar;